import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SortReqData } from "../../../../data/sortReqData";
import Select from "./../../../../common/select";
import RequirementCard from "./../../../Card/Requirement/RequirementCard";
import Pagination from "./../../../../common/pagination";
import { paginate } from "./../../../../utils/paginate";

const Recent = ({ requirement, myAccount, status }) => {
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    navigate(`/buyerdashboard/PostRequirementForm/${item.id}`);
  };

  return (
    <>
      <RequirementCard
        requirement={requirement}
        onNavigate={handleNavigate}
        myAccount={myAccount}
        status={status}
      />
    </>
  );
};

export default Recent;
